import React from 'react';
import { Link } from 'react-router-dom';
import { User } from '../utils/auth';
import './NavMenu.css';

interface NavMenuProps {
    onClose: () => void;
    onLogout: () => void;
    user: User | null;
}

const NavMenu: React.FC<NavMenuProps> = ({ onClose, onLogout }) => {

    return (
        <div className="nav-menu">
            <Link to="/" onClick={onClose}>Home</Link>
            <Link to="/" onClick={() => { onClose(); onLogout(); }}>Logout</Link>
        </div>
    );
};

export default NavMenu;